export const InvoiceStatus = {
  DRAFT: { label: 'Draft', value: 'draft' },
  SUBMITTED: { label: 'Submitted', value: 'submitted' },
  APPROVED: { label: 'Approved', value: 'approved' },
  COMPLETED: { label: 'Completed', value: 'completed' },
  REJECTED: { label: 'Rejected', value: 'rejected' },
  BILL_PROCESSED: { label: 'Bill Processed', value: 'bill_processed' },
  PAY_PROCESSED: { label: 'Pay Processed', value: 'pay_processed' },
} as const;
